import { useState, useEffect } from "react";

/**
 * Hook to detect if the device has a fine pointer (mouse/trackpad) vs coarse (touch).
 * Returns false initially for SSR, then updates on mount to avoid hydration mismatch.
 */
export function useHasFinePointer(): boolean {
  const [hasFinePointer, setHasFinePointer] = useState(false);

  useEffect(() => {
    setHasFinePointer(window.matchMedia("(pointer: fine)").matches);
  }, []);

  return hasFinePointer;
}
